import axios from 'axios'

// get请求Api
export const getApi = (url, params) => {
    if (process.env.NODE_ENV === 'development') {
        document.cookie = "sid=9d5ef85b23e6414fac95f2bbc1967ca6;"; 
        document.cookie = "uuid=df2d4082b30ef8da;"; 
    } ;

    return axios({
        url,
        params
    })
}
// pos请求Api 
export const postApi = (url, data) => {
    return axios({
        url,
        data,
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}

export const postApiJson = (url, data) => {
    return axios({
        url,
        data,
        method: 'POST',
    })
}

// pos请求Api 
export const postDataApi = (url, data) => {
    return axios({
        url,
        data,
        method: 'POST',
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}





//////////////////
// WEBPACK FOOTER
// ./utils/request.js
// module id = null
// module chunks = 